<template>
	<span class="ht-icon">
		{{ name }}
	</span>
</template>

<script lang="ts" setup>
defineProps<{
	name: string;
}>();
</script>
